module.exports = __webpack_public_path__ + "static/media/arrow-down.cc2488b0.svg";